import { CarePlanSignatureRequest } from './CarePlanSignatureRequest';

export default interface ICarePlanDualSignatureRequest {
    ProviderSignature?: CarePlanSignatureRequest | null;
    MemberSignature?: CarePlanSignatureRequest | null;
}

export class CarePlanDualSignatureRequest implements ICarePlanDualSignatureRequest {
    ProviderSignature?: CarePlanSignatureRequest | null;
    MemberSignature?: CarePlanSignatureRequest | null;

    constructor() {
        this.ProviderSignature = null;
        this.MemberSignature = null;
    }
}
